import { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import { AuthenticationAction, AuthenticationGetter, AuthenticationMutation, AuthenticationState } from './types'

const namespaced: boolean = true
export const authentication: Module<AuthenticationState,any> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
}

export const types = {
  action:  AuthenticationAction,
  mutation: AuthenticationMutation,
  getter: AuthenticationGetter,
}

export const domain = 'authentication'

export const vuexModule = {
  [domain]: authentication,
}